<template>
  <div class="view content">
    <div class="container content">
      <div class="header">Mentions légales</div>
      <div class="content">
        <div>
          <h3>DENOMINATION SOCIALE</h3>
          <p>Vous êtes actuellement connecté au site « kyc.infogreffe.fr » qui est la propriété exclusive du GIE INFOGREFFE.</p>
        </div>

        <div>
          <h3>INFOGREFFE, Immeuble Le Parisien - 5-7, avenue de Paris 94300 VINCENNES</h3>
          <p>Forme juridique : Groupement d'intérêt économique</p>
          <p>N° d'inscription au Registre du Commerce et des Sociétés de CRETEIL : 338 885 718</p>
          <p>Nomenclature d'activités françaises : 8291Z</p>
          <p>Numéro de TVA intracommunautaire : FR69338885718</p>
          <p>Directeur de la Publication : Maître Dieudonné MPOUKI</p>
          <p>Directeur de la Rédaction : Monsieur Jean CHRISTOPHE</p>
          <p>Téléphone : 01 41 74 72 72 ou 01 86 86 05 78</p>
          <p>
            Les informations sont données à titre indicatif. Seuls ont une valeur juridique les originaux conservés aux greffes, auxquels il peut être demandé
            une copie de l'acte original.
          </p>
        </div>

        <div>
          <h3>HEBERGEMENT</h3>
          <p>
            Les données informatiques sont hébergées par l'entreprise suivante : Microsoft Azure (téléphone : 01 57 32 42 18) , société immatriculée au registre
            du commerce et des sociétés de Nanterre sous le numéro 327 733 184
          </p>
          <p>
            La navigation sur ce site est soumise à la réglementation en vigueur et aux conditions générales d'utilisation définies ci-après :
            <RouterLink :to="{ name: 'cgv' }">CONDITIONS GENERALES D'UTILISATION ET CONDITIONS GENERALES DE VENTE.</RouterLink>
          </p>
          <p>
            Le GIE INFOGREFFE se réserve le droit de modifier ou d'adapter à tout moment les mentions légales. En conséquence, nous vous invitons à les
            consulter régulièrement.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
.view {
  display: flex;
  justify-content: center;

  padding-top: 90px;
}

.container {
  margin: 96px 0;
  max-width: 987px;

  a {
    color: colors.$main-color;
    text-decoration: underline;
    cursor: pointer;
    transition: 0.1s;

    &:hover {
      opacity: 0.8;
    }
  }
}

.header {
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;

  display: flex;
  align-items: center;

  color: colors.$darkblue-color;

  margin-bottom: 24px;
}

@media only screen and (max-width: responsive.$layout-breakpoint-small) {
  .container {
    margin: 42px 0 !important;
  }
}
</style>
